import * as React from 'react'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Web3 from 'web3'
import { useState, useEffect } from 'react'
import { Avatar, Button, Typography, CircularProgress } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import './Blocks.css'
import './transactions.css'
import { ethers } from 'ethers'

export default function Transactions() {
  const navigate = useNavigate()
  const web3 = new Web3()

  web3.setProvider('https://rpc.Dexit.network')

  const [dd, setdd] = useState([])
  const [dummyData, setDummyData] = useState([])

  useEffect(() => {
    Init()
    reInit()
    return () => { }
  }, [])

  async function Init() {
    try {
      let bc = []
      let currentBlock = await web3.eth.getBlockNumber()
      for (let j = currentBlock - 1; j <= currentBlock; j++) {
        let getBlockDetails = await web3.eth.getBlock(j)

        if (getBlockDetails.transactions.length > 0) {
          for (let k = 0; k < getBlockDetails.transactions.length; k++) {
            let getTransactionDetails = await web3.eth.getTransactionReceipt(
              getBlockDetails.transactions[k],
            )
            bc.push(getTransactionDetails)
          }
        }
      }
      setdd([...dd, ...bc])
    } catch (error) {
      console.log(error)
    }
  }

  async function reInit() {
    try {
      let demo = []
      let blocks = []
      let blocksDetails = [239331]
      for (let j = 0; j < blocksDetails.length; j++) {
        let getBlockDetails = await web3.eth.getBlock(blocksDetails[j])

        console.log(getBlockDetails)
        if (getBlockDetails.transactions.length > 0) {

          for (let k = 0; k < getBlockDetails.transactions.length; k++) {
            let getTransactionDetails = await web3.eth.getTransactionReceipt(
              getBlockDetails.transactions[k],
            )
            demo.push(getTransactionDetails)
          }
        }
      }


      setDummyData([...dummyData, ...demo])
    } catch (error) {
      console.log(error)
    }
  }

  // async function searchTransactionByBlock() {
  //   try {
  //     let ab = [];
  //     let tr = await web3.eth.getBlock(searchBlock);
  //     console.log("transactions list", tr.transactions);
  //     for (let i = 0; i < tr.transactions.length; i++) {
  //       let getTrans = await web3.eth.getTransaction(tr.transactions[i]);
  //       console.log("transaction", getTrans);
  //       ab.push(getTrans);
  //     }
  //     setdd(ab);
  //     console.log("dd", ab);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  // async function searchTransactionByTransactionHash() {
  //   try {
  //     let ab = [];
  //     console.log(searchBlock);
  //     let tr = await web3.eth.getTransaction(searchBlock);
  //     console.log("transaction details", tr);
  //     ab.push(tr);
  //     setdd(ab)
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  const shortenAccountId = (fullStr) => {
    const strLen = 20
    const separator = '...'

    if (fullStr?.length <= strLen) return fullStr

    const sepLen = separator.length
    const charsToShow = strLen - sepLen
    const frontChars = Math.ceil(charsToShow / 2)
    const backChars = Math.floor(charsToShow / 2)

    return (
      fullStr?.substr(0, frontChars) +
      separator +
      fullStr?.substr(fullStr?.length - backChars)
    )
  }
  const handleViewAllTxs = () => {
    navigate('/alltransactions')
  }

  const handleTransactionInfo = (transactionHash) => {
    navigate('/hashinfo', { state: { details: transactionHash } })
  }

  return (
    <>
      {/* {console.log("Transactions length", dd.length)} */}
      <div className="transaction_body">
        <TableContainer
          component={Paper}
          sx={{
            padding: '1rem',
            width: 'initial',
            borderRadius: '20px',
            color: '#FFFFF9',
            backgroundColor: '#2C2E3F',
          }}
        >
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <Typography sx={{ padding: 1 }}>Latest Transactions</Typography>
              </TableRow>
              {/* <TableRow style={{ background: 'whitesmoke' }}> */}
              {/* <TableCell >Transaction Hash</TableCell> */}
              {/* <TableCell align="left">Transactions</TableCell> */}
              {/* <TableCell align="left">To</TableCell> */}
              {/* <TableCell align="left">Block</TableCell> */}
              {/* <TableCell align="left">Block hash</TableCell> */}
              {/* </TableRow> */}
            </TableHead>
            {dd.length > 0 ? (
              <TableBody
                sx={{
                  height: '500px !important',
                  overflowY: 'auto',
                  display: 'block',
                }}
              >
                {dd
                  .slice(0)
                  .reverse()
                  .map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        cursor: 'pointer',
                        padding: 1,
                      }}
                      onClick={() => handleTransactionInfo(row.transactionHash)}
                    >
                      <TableRow>
                        <TableCell sx={{ width: '8rem' }}></TableCell>
                        <TableCell sx={{ width: '20rem' }}></TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>TX Hash</TableCell>
                        <TableCell>{shortenAccountId(row.blockHash)}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Block</TableCell>
                        <TableCell>{row.blockNumber}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>From</TableCell>
                        <TableCell>{shortenAccountId(row.from)}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>To</TableCell>
                        <TableCell>
                          {row.to == null
                            ? shortenAccountId(row.contractAddress)
                            : shortenAccountId(row.to)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Amount (DXT)</TableCell>
                        <TableCell>
                          {ethers.utils.formatUnits(row.gasUsed, 9)}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        sx={{
                          '& td, & th': {
                            borderBottom: '1px solid #8997b1 !important',
                          },
                        }}
                      >
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableRow>
                  ))}
              </TableBody>
            ) : (
              <TableBody
                sx={{
                  height: '500px !important',
                  overflowY: 'auto',
                  display: 'block',
                }}
              >
                {dummyData.length > 0 ? (
                  dummyData
                    .slice(0)
                    .reverse()
                    .map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          cursor: 'pointer',
                          padding: 1,
                        }}
                        onClick={() =>
                          handleTransactionInfo(row.transactionHash)
                        }
                      >
                        <TableRow>
                          <TableCell sx={{ width: '8rem' }}></TableCell>
                          <TableCell sx={{ width: '20rem' }}></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>TX Hash</TableCell>
                          <TableCell>
                            {shortenAccountId(row.transactionHash)}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Block</TableCell>
                          <TableCell>{row.blockNumber}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>From</TableCell>
                          <TableCell>{shortenAccountId(row.from)}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>To</TableCell>
                          <TableCell>
                            {row.to == null
                              ? shortenAccountId(row.contractAddress)
                              : shortenAccountId(row.to)}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          {console.log(row)}
                          <TableCell>Amount (DXT)</TableCell>
                          <TableCell>
                            {ethers.utils.formatUnits(row.gasUsed, 9)}
                          </TableCell>
                        </TableRow>
                        <TableRow
                          sx={{
                            '& td, & th': {
                              borderBottom: '1px solid #8997b1 !important',
                            },
                          }}
                        >
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableRow>
                    ))
                ) : (
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress />
                  </Box>
                )}
              </TableBody>
            )}
          </Table>
          <Button
            className="blocksBtn"
            variant="contained"
            color="grey"
            fullWidth
            onClick={handleViewAllTxs}
            size="large"
          >
            View All Transactions
          </Button>
        </TableContainer>
      </div>
    </>
  )
}
